<template>
  <AdminLayout>
    <Head title="Edit Supplier" />

    <div class="headline flex flex-row justify-between mx-4 sm:mx-12">
      <h2 class="text-2xl font-semibold pb-5 pt-5 text-blue-600">Edit Supplier</h2>

      <div class="relative inline-flex shadow-sm rounded-md self-start mt-2">
        <button
          @click.prevent="submit()"
          :disabled="form.processing"
          type="button"
          class="inline-flex items-center px-4 py-3 mr-3 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
        >
          Save Changes
        </button>
        <button
          @click.prevent="deleteSupplier()"
          :disabled="form.processing"
          type="button"
          class="inline-flex items-center px-4 py-3 mr-3 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-red-600 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600"
        >
          Delete Supplier
        </button>
      </div>
    </div>

    <div
      v-if="$page.props.flash.success"
      class="alert alert-success"
    >
      <p class="alert-text">
        {{ $page.props.flash.success }}
      </p>
    </div>

    <div class="form bg-gray-100 flex-1 py-10 px-4 sm:px-12">
      <form
        method="POST"
        @submit.prevent="submit()"
      >
        <div class="grid grid-cols-12 gap-6">
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="name"> Name </label>
            <input
              type="text"
              v-model="form.name"
              name="name"
              id="name"
              autocomplete="name"
            />
            <p
              v-if="getErrors('name')"
              class="input-error"
            >
              {{ getErrors('name') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="license_number"> License Number </label>
            <input
              type="text"
              v-model="form.license_number"
              name="license_number"
              id="license_number"
              autocomplete="license_number"
            />
            <p
              v-if="getErrors('license_number')"
              class="input-error"
            >
              {{ getErrors('license_number') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="street_1"> Address 1 </label>
            <input
              type="text"
              v-model="form.contact.street_1"
              name="street_1"
              id="street_1"
              autocomplete="street_1"
            />
            <p
              v-if="getErrors('contact.street_1')"
              class="input-error"
            >
              {{ getErrors('contact.street_1') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="street_2"> Address 2 </label>
            <input
              type="text"
              v-model="form.contact.street_2"
              name="street_2"
              id="street_2"
              autocomplete="street_2"
            />
            <p
              v-if="getErrors('contact.street_2')"
              class="input-error"
            >
              {{ getErrors('contact.street_2') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="city"> City </label>
            <input
              type="text"
              v-model="form.contact.city"
              name="city"
              id="city"
              autocomplete="city"
            />
            <p
              v-if="getErrors('contact.city')"
              class="input-error"
            >
              {{ getErrors('contact.city') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="state"> State </label>
            <select
              v-model="form.contact.state"
              name="state"
              id="state"
              autocomplete="state"
            >
              <option value="">Select a state</option>
              <option
                v-for="(state, value) in page.props.util.states"
                :value="value"
                :key="value"
              >
                {{ state }}
              </option>
            </select>
            <p
              v-if="getErrors('contact.state')"
              class="input-error"
            >
              {{ getErrors('contact.state') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="zip"> Postal Code </label>
            <input
              type="text"
              v-model="form.contact.zip"
              name="zip"
              id="zip"
              autocomplete="zip"
            />
            <p
              v-if="getErrors('contact.zip')"
              class="input-error"
            >
              {{ getErrors('contact.zip') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="contact_first_name"> Contact First Name </label>
            <input
              type="text"
              v-model="form.contact.first_name"
              name="contact_first_name"
              id="contact_first_name"
              autocomplete="contact_first_name"
            />
            <p
              v-if="getErrors('contact.first_name')"
              class="input-error"
            >
              {{ getErrors('contact.first_name') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="contact_last_name"> Contact Last Name </label>
            <input
              type="text"
              v-model="form.contact.last_name"
              name="contact_last_name"
              id="contact_last_name"
              autocomplete="contact_last_name"
            />
            <p
              v-if="getErrors('contact.last_name')"
              class="input-error"
            >
              {{ getErrors('contact.last_name') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="contact_email"> Contact Email </label>
            <input
              type="email"
              v-model="form.contact.email"
              name="contact_email"
              id="contact_email"
              autocomplete="contact_email"
            />
            <p
              v-if="getErrors('contact.email')"
              class="input-error"
            >
              {{ getErrors('contact.email') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="contact_phone"> Contact Phone </label>
            <input
              type="tel"
              v-model="form.contact.phone"
              name="contact_phone"
              id="contact_phone"
              autocomplete="contact_phone"
            />
            <p
              v-if="getErrors('contact.phone')"
              class="input-error"
            >
              {{ getErrors('contact.phone') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="lead_time_days"> Lead Time Days </label>
            <input
              type="number"
              v-model="form.lead_time_days"
              name="lead_time_days"
              id="lead_time_days"
              autocomplete="lead_time_days"
            />
            <p
              v-if="getErrors('lead_time_days')"
              class="input-error"
            >
              {{ getErrors('lead_time_days') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="notes"> Notes </label>
            <textarea
              v-model="form.notes"
              name="notes"
              id="notes"
            ></textarea>
            <p
              v-if="getErrors('notes')"
              class="input-error"
            >
              {{ getErrors('notes') }}
            </p>
          </div>
        </div>
      </form>
    </div>
  </AdminLayout>
</template>

<script setup>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, useForm, usePage } from '@inertiajs/vue3'
import { useConfirmDialog } from '@/Composables/confirm-dialog'
import { settle } from '@/utils/promises'

const props = defineProps({
  supplier: Object,
  errors: Object
})

const page = usePage()

const form = useForm({
  name: '',
  license_number: '',
  notes: '',
  lead_time_days: '',
  contact: {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    street_1: '',
    street_2: '',
    city: '',
    state: '',
    zip: ''
  },
  ...(props.supplier.data || {})
})

const submit = () => {
  form.put(route('company.suppliers.update', props.supplier.data.id))
}

const deleteSupplier = async () => {
  const { show } = useConfirmDialog()
  const [error, data] = await settle(
    show({
      type: 'danger',
      confirmText: 'Delete',
      body: "Are you sure you want to delete this supplier? This can't be undone."
    })
  )

  if (!error) {
    useForm({}).delete(route('company.suppliers.destroy', props.supplier.data.id))
  }
}

const getErrors = (field) => {
  if (field in props.errors) {
    return props.errors[field]
  }

  return ''
}
</script>
